// @flow

import ScrollBooster from "scrollbooster";

type PropsType = {
    $element: HTMLElement,
};

class Scroller {
    props: PropsType;
    $el: HTMLElement;
    $innerWrapper: HTMLElement;

    constructor(props: PropsType) {
        this.$el = props.$element;
        this.$content = this.$el.querySelector("[data-scroller-content]");

        this.init();
    }

    init() {
        if (this.$el && this.$content) {
            // const scrollbarHeight =
            //     this.$el.offsetHeight - this.$content.clientHeight;
            // console.log(scrollbarHeight);

            // this.$el.style.height = this.$content.clientHeight + "px";

            new ScrollBooster({
                viewport: this.$el,
                content: this.$content,
                scrollMode: "native",
                direction: "horizontal",
            });
        }
    }
}

export default Scroller;
